import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {
    TrendingGamesRecommendations,
    TrendingRecommendationTypeEnum
} from "../ai-recommendations-reader.service.interface";

export class TrendingGamesRecommendationsModel {
    constructor(private readonly services: IServiceFactoryExtended) {
    }

    private _cache: TrendingGamesRecommendations = ({} as any);

    async getRecommendations(recommendationTypes: TrendingRecommendationTypeEnum[]): Promise<TrendingGamesRecommendations> {

        const recommendationTypesToQueryFromServer: TrendingRecommendationTypeEnum[] = recommendationTypes.filter(rt => !(this._cache[rt]));


        if(recommendationTypesToQueryFromServer.length > 0) {
            const countryCode = this.services.sdk.getCountryIso3();

            const apiResponse = await this.services.api.insightController.getTrendingRecommendedGamesForPlayer({
                countryCode: countryCode,
                subBrandId: this.services.sdk.getSubBrandID(),
                listTypeIds: recommendationTypesToQueryFromServer
            }) ?? {};

            for(let recomType of Object.keys(apiResponse)) {
                this._cache[recomType] = apiResponse[recomType] ?? [];
            }
        }

        let result: TrendingGamesRecommendations = ({} as any);

        for(let recomType of recommendationTypes) {
            if(this._cache[recomType]) {
                result[recomType] = this._cache[recomType];
            }
        }

        return result;

    }
}